import {SystemStatusGroup} from "../../../core/gd/const/system-status";
import {TasksViewAppSettings} from "../../../core/gd-modules/tasks-view/core/@types";
import {SystemColumnType} from "../../../core/gd-modules/manager/columns/types";

export const viewTableDefaultAppSettings : TasksViewAppSettings =  {
    columns                 :[
        {
            id      : SystemColumnType.TITLE
        },
        {
            id      : SystemColumnType.ACTION_REQUIRED
        },
        {
            id      : SystemColumnType.SCHEDULE
        },
        {
            id      : SystemColumnType.PRIORITY
        },
        {
            id      : SystemColumnType.STATUS
        },
    ],
    systemStatusFilter      : SystemStatusGroup.ALL,
    sortBy                  : null,
    filters                 : {},
    areEmptyFoldersHidden   : false
}